<template>
  <Page title="New Warranty Program">
    <Breadcrumbs
      :crumbs="crumbs"
      root-text="Warranty Programs"
      class="mb-3"
      @click="handleCrumbClick"
    />
    <WarrantyProgramForm />
  </Page>
</template>

<script>
import WarrantyProgramForm from "@/WarrantyPrograms/WarrantyProgramForm.vue";
import Page from "@/components/Page.vue";
export default {
  components: {
    Page,
    WarrantyProgramForm,
  },
  data() {
    return {
      crumbs: [
        {
          id: "New Warranty Program",
          label: "New Warranty Program",
        },
      ],
    };
  },
  methods: {
    handleCrumbClick(crumb) {
      if (crumb.id === "root") {
        this.$router.push(this.warrantyProgramIndexPath());
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
